import { z } from "zod";

export const Sizes: Record<string, [w: number, h: number]> = {
  "6x4": [6, 4],
  "8x4": [8, 4],
  "8x6": [8, 6],
  "12x4": [12, 4],
  "12x6": [12, 6],
  "12x8": [12, 8],
};

export const tableSettingsFormSchema = z.object({
  arrayField: z.string(),
  title: z.string().default("Custom Table"),
  columns: z.array(
    z.object({
      enabled: z.boolean(),
      fieldName: z.string(),
      columnName: z.string(),
      columnType: z.enum([
        "string",
        "number",
        "boolean",
        "date",
        "array",
        "object",
        "unknown",
      ]),
      columnDisplay: z.string().default("default"),
      columnDisplayProps: z.record(z.string(), z.unknown()).default({}),
      columnStyle: z
        .object({
          display: z.string().default("default"),
          color: z.string().default("default"),
          backgroundColor: z.string().default("default"),
          fontSize: z.number().default(14),
          fontWeight: z.string().default("default"),
          fontStyle: z.array(z.enum(["italic"])).default([]),
          textDecoration: z.string().default("default"),
        })
        .prefault({}),
    }),
  ),
});
